import { BbSelectOption } from 'app/components/shared/bb-select/bb-select.component';
import { Component, Input, OnInit, HostBinding } from '@angular/core';

@Component({
	selector: 'bb-list',
	templateUrl: './bb-list.component.html',
	styleUrls: ['./bb-list.component.scss']
})
export class BbListComponent implements OnInit {
	@Input() options: BbSelectOption[];
	@Input() type: 'ordered' | 'unordered' = 'unordered';
	@Input() limit = 0;

	constructor() { }

	ngOnInit(): void {
	}

}
